import type { LiveSource } from '@bldsoft/cappie/live'
import type { Store } from 'effector'

/**
 * Effector store as Cappie {@link LiveSource}: pull via call, push via subscribe.
 */
export function live<T>(store: Store<T>): LiveSource<T> {
  const get = (): T => store.getState()
  get.subscribe = (callback: (value: T) => void) =>
    store.updates.watch(callback)
  return get
}
